import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0382e2a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "three-dots-wrapper tw-cursor-pointer" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "tw-flex tw-flex-row tw-items-center tw-h-[36px]" }
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "tw-h-[39px] tw-w-[39px]"
}
const _hoisted_6 = {
  key: 1,
  class: ""
}
const _hoisted_7 = ["id", "onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[1.5px] tw-bg-white tw-h-[36px]" }, null, -1))
const _hoisted_9 = { style: {"max-width":"max-content"} }

import CustomDropDown from "./customDropDown.vue";
import ArrowButtonIcon from "../svgs/arrowButtonIcon.vue";
import { onBeforeUnmount, onMounted, ref, nextTick } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'buttonDropdown',
  props: {
  active: { type: Boolean, required: false, default: true },
  buttonClass: { type: String, required: false, default: "" },
  arrowClass: { type: String, required: false, default: "" },
  title: { type: String, required: false, default: "" },
  colorText: { type: String, default: "#FFF" },
  disabled: { type: Boolean, default: false },
  activeDropdown: { type: Boolean, required: false, default: false },
  idPopover: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  classes: {
    type: String,
    required: false,
    default: "",
  },
  dataType: {
    type: String,
    required: false,
    default: "",
  },
  idBtn: {
    type: String,
    required: false,
    default: "",
  },
  isLoadingAnimation: {
    type: Boolean,
    required: false,
    default: false,
  },
  withBtn: {
    type: String,
    required: false,
    default: "max-content",
  },
},
  emits: ["click-dropdown", "click-title", "leave"],
  setup(__props, { emit: emits }) {

const props = __props;



const dropdownRef = ref<HTMLDivElement | null>(null);
const btnRef = ref<HTMLDivElement | null>(null);
const buttonWidth = ref(0);



const openDropdown = () => {
  EventEmitter.emit(EmitterEvents.OPEN_SCAN_POPOVER, props.dataType);
  setTimeout(() => {
    emits("click-dropdown");
  }, 50);
};

const handleShow = (value) => {
  if (!value) {
    emits("leave");
  }
};

onMounted(async () => {
  window.addEventListener("click", onClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", onClickOutside);
});

const onClickOutside = (event) => {
  emits("leave");
};

const handleClickTitle = async () => {
  await nextTick();
  if (btnRef.value) {
    buttonWidth.value = btnRef.value.offsetWidth;
  }
  emits("click-title");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    tabindex: 0,
    class: _normalizeClass(`${__props.classes} tw-cursor-pointer`)
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("button", {
        disabled: __props.disabled,
        variant: "primary",
        class: _normalizeClass([
          `'tw-bg-[#387DFF] tw-text-[${__props.colorText}] !tw-p-0 tw-flex tw-w-fit tw-text-[13px]  tw-leading-[normal] tw-font-medium tw-rounded-[100px] tw-h-[36px] tw-items-center'`,
          __props.active ? '' : 'disable-button',
          __props.buttonClass,
        ])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            id: __props.idBtn,
            ref_key: "btnRef",
            ref: btnRef,
            class: _normalizeClass(`tw-py-[8px] tw-pr-[12px] tw-pl-[18px] tw-flex tw-items-center tw-justify-center`),
            style: _normalizeStyle({
              minWidth: buttonWidth.value ? buttonWidth.value + 'px' : 'max-content',
            }),
            onClick: _withModifiers(handleClickTitle, ["stop"])
          }, [
            (__props.isLoadingAnimation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_unref(LottieAnimation), {
                    ref: "anim",
                    "animation-data": _unref(ProgressAnimation),
                    "auto-play": true,
                    loop: true
                  }, null, 8, ["animation-data"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.title), 1))
          ], 12, _hoisted_4),
          _createElementVNode("div", {
            id: __props.idPopover,
            class: "tw-flex tw-items-center tw-relative",
            onClick: _withModifiers(openDropdown, ["stop"])
          }, [
            _hoisted_8,
            _createVNode(ArrowButtonIcon, {
              class: _normalizeClass(`tw-ml-[12px] tw-mr-[14px] ${__props.arrowClass}`),
              color: __props.colorText
            }, null, 8, ["class", "color"])
          ], 8, _hoisted_7)
        ])
      ], 10, _hoisted_2)
    ]),
    _createVNode(CustomDropDown, {
      "id-popover": __props.idPopover,
      class: _normalizeClass(!__props.activeDropdown ? 'tw-invisible' : ''),
      "custom-class": __props.customClass,
      placement: 'bottom-end',
      timeout: 99999999999,
      onOnHover: handleShow
    }, _createSlots({ _: 2 }, [
      (__props.activeDropdown)
        ? {
            name: "default",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["id-popover", "class", "custom-class"])
  ], 2))
}
}

})